export interface Comment {
  id: string;
  ticketId: string;
  user: string;
  comment: string;
  createdDate: string;
  updatedDate?: string;
  isDeleted?: boolean;
}

export function DefaultComment(): Comment {
  return {
    id: '',
    ticketId: '',
    user: '',
    comment: '',
    createdDate: '',
    updatedDate: '',
    isDeleted: false,
  };
}
